export default __webpack_public_path__ + "static/media/sa-icon.81f69262.webp";